// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"21b5abb5","339":"233d5c0d","548":"36698092"}[chunkId] + ".chunk.js";
};